/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import Loader from '../../../common/LoadingSpinner';
import InfiniteScroll from '../../../common/InfiniteScroll';
import StatusCell from '../../../common/StatusCell';
import { SERVER_URL } from '../../../../config';
import MobileFilters from './Filters';
import * as api from '../../../../epics/api';
import { flatShifts } from '../../../../epics/shiftsEpic';
import ShiftTableSubComponent from '../ShiftTableSubComponent';
import { withPushFiltersToUrl } from '../../common/decorators';

import history from '../../../../history';

@withPushFiltersToUrl
export default class MobileTableCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            nextPage: this.props.meta.next,
            hasMoreItems: !!this.props.meta.next,
            indexToShowActions: null,
            isModalConfirmCancelShiftOpen: false,
        };
        this.loadMoreEntries = this.loadMoreEntries.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.state.data) {
            this.setState({
                data: nextProps.data,
                nextPage: nextProps.meta.next,
                hasMoreItems: !!nextProps.meta.next,
                indexToShowActions: null,
            });
        }
    }

    loadMoreEntries(page) {
        const currentUrlParams = new URLSearchParams(history.location.search);
        api.executeHttpRequest(this.state.nextPage, 'get', {}, false).then(
            res => {
                const results = flatShifts(currentUrlParams, res.data);
                this.setState({
                    data: [...this.state.data, ...results.content],
                    nextPage: res.data.meta.next,
                    hasMoreItems: !!res.data.meta.next,
                    indexToShowActions: null,
                });
            },
        );
    }

    handleCardClick = (id, i) => e => {
        this.setState(prevState => ({
            ...prevState,
            indexToShowActions: prevState.indexToShowActions === i ? null : i,
        }));
    };

    updateJobStatus = (jobId, status, data = {}) => {
        api.updateJobStatus({ jobId, status, data })
            .then(() => {
                this.props.reloadData();
            })
            .catch(() => {
                this.props.notification.error(
                    'Error',
                    'Could not change the status of the job',
                );
            });
    };

    editJob = jobId => {
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (this.props.user.isClient) {
            history.push(`/job/edit/${jobId}`);
        } else {
            history.push({
                pathname: `/jobs/list/edit/${jobId}`,
                search: currentUrlParams.toString(),
            });
        }
    };

    viewJob = jobId => {
        window.location.assign(`${SERVER_URL}/job/${jobId}`);
    };

    duplicateJob = jobId => {
        const currentUrlParams = new URLSearchParams(history.location.search);
        history.push({
            pathname: `/jobs/list/duplicate/${jobId}`,
            search: currentUrlParams.toString(),
        });
    };

    loadCheckoutLink = jobId => {
        history.push(`/jobs/list/check-out-link/${jobId}`);
    };

    renderFreelancerInfo = job => {
        let extraClass;
        let freelancerImg;
        let jobHasBooking = false;
        if (job.booking) {
            freelancerImg = job.booking.freelancer_detail.photo_thumbnail_large;
            jobHasBooking = true;
        } else {
            freelancerImg = '/static/images/default_profile.png';
            extraClass = 'dotted';
        }

        return (
            <div className="freelancer-sec">
                <a
                    className="group-link"
                    href={freelancerImg}
                    target="_blank"
                    rel="noreferrer"
                >
                    <div
                        className={`avatar ${extraClass}`}
                        style={{ backgroundImage: `url(${freelancerImg})` }}
                    />
                </a>
                {jobHasBooking ? (
                    <p>{job.booking.freelancer_detail.full_name}</p>
                ) : (
                    <p>
                        {job.bookings.length}/{job.number_of_freelancers}
                    </p>
                )}
            </div>
        );
    };

    handleOpenModal = modalName => {
        this.setState(prevState => ({
            ...prevState,
            [`isModal${modalName}Open`]: true,
        }));
    }

    handleCloseModal = modalName => {
        this.setState(prevState => ({
            ...prevState,
            [`isModal${modalName}Open`]: false,
        }));
    }

    renderCards = () => {
        let jobListCardsDivs;

        jobListCardsDivs = this.state.data.map((job, i) => (
            <div className="card" key={i}>
                <div onClick={this.handleCardClick(job.id, i)}>
                    <h5>
                        <i className="icon icon-calendar-2 small prepend" />{' '}
                        {moment(job.date).format('DD/MM/YYYY')}{' '}
                        <i className="icon icon-clock-2 small prepend" />{' '}
                        {moment(job.start_datetime).format('HH:mm')}{' '}
                    </h5>
                    <div className="content">
                        <div className="info">
                            {job.reference_number}{' '}
                            <StatusCell
                                jobStatus={job.status}
                                booking={job.booking}
                                additionalServices={job.additional_services}
                                delegated={job.owned && !job.managed}
                            />
                            <p>
                                {this.props.user.isAgent ? (
                                    <strong>{job.client_full.company_name}</strong>
                                ) : null}
                            </p>
                            <div>
                                <span className="f20 marb10 inlineblock">
                                    <i className="icon large icon-food-dome-serving-1" />
                                </span>
                                <span className="label label-default">
                                    {' '}
                                    {job.service_role}
                                </span>
                            </div>
                            <div>
                                <p>
                                    <i className="icon icon-map-pin-1 small prepend" />{' '}
                                    {job.postcode}
                                </p>
                            </div>
                        </div>
                        <div className="freelancer">
                            {this.renderFreelancerInfo(job)}
                        </div>
                    </div>
                </div>
                {i === this.state.indexToShowActions ? (
                    <ShiftTableSubComponent
                        job={job}
                        user={this.props.user}
                        updateJobStatus={this.updateJobStatus}
                        editJob={this.editJob}
                        duplicateJob={this.duplicateJob}
                        loadCheckoutLink={this.loadCheckoutLink}
                        viewJob={this.viewJob}
                        handleOpenModal={this.handleOpenModal}
                        handleCloseModal={this.handleCloseModal}
                        isModalConfirmCancelShiftOpen={this.state.isModalConfirmCancelShiftOpen}
                    />
                ) : null}
            </div>
        ));

        return jobListCardsDivs;
    };

    onCreate = event => {
        const { user, history } = this.props;
        const currentUrlParams = new URLSearchParams(history.location.search);
        if (
            user.isClient ||
            (user.isAgent && user.agency.features.includes('booking_tunnel'))
        ) {
            history.push('/job/create');
        } else {
            history.push({
                pathname: '/jobs/list/create',
                search: currentUrlParams.toString(),
            });
        }
    };

    onFilterChange = (id, value) => {
        let searchParams;
        const self = this;
        if (value.hasOwnProperty('value')) {
            const filter = {};
            filter[id] = value.value;
            searchParams = self.props.pushFiltersToParamter(filter);
        } else {
            searchParams = self.props.pushFiltersToParamter(value);
        }
    };

    render() {
        const service = new URLSearchParams(history.location.search).get(
            'service',
        );

        return (
            <InfiniteScroll
                pageStart={1}
                loadMore={this.loadMoreEntries}
                initialLoad={true}
                hasMore={this.state.hasMoreItems}
                loader={
                    <div className="loading-more-mobile">
                        <Loader color="gray" />
                    </div>
                }
                className="mobile-table-card-container"
            >
                <div className="mobile-table-card">
                    <MobileFilters
                        history={history}
                        user={this.props.user}
                        isMobile={this.props.isMobile}
                        onCreate={this.onCreate}
                        data={this.state.data}
                        onFilterChange={this.onFilterChange}
                    />
                    {this.state.data.length > 0 ? (
                        this.renderCards()
                    ) : this.props.loading ? (
                        <p>Fetching bookings ...</p>
                    ) : (
                        <div>
                            <p>No bookings.</p>
                        </div>
                    )}
                </div>
            </InfiniteScroll>
        );
    }
}
